import { ApiError } from '@types';
import { AxiosRequestConfig } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { config } from '../../config';

export const fetchCmsContentAsync = createAsyncAction(
    [
        'Cms/FETCH_CMS_CONTENT_REQUEST',
        (endpoint: string) => {
            return {
                url: `${config.env('cmsUrl')}/webcontent/contents/${endpoint}`,
                method: 'get'
            } as AxiosRequestConfig;
        }
    ],
    ['Cms/FETCH_CMS_CONTENT_SUCCESS', (response: any) => response],
    ['Cms/FETCH_CMS_CONTENT_ERROR', (error: ApiError) => error],
    'Cms/FETCH_CMS_CONTENT_CANCEL'
)();
